import axios from "axios";
import ResourceService from "./resource.service";

class AuthService extends ResourceService {
  static get resource() {
    return "auth";
  }

  static exchangeAuthorizationCode(params) {
    const config = {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      },
      url = process.env.VUE_APP_KEYCLOAK_URL + `/token`;

    return new Promise((resolve, reject) => {
      axios
        .post(url, params, config)
        .then(({ data }) => {
          resolve(data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  static refreshToken(params) {
    const config = {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      },
      url = process.env.VUE_APP_KEYCLOAK_URL + `/token`;

    return new Promise((resolve, reject) => {
      axios
        .post(url, params, config)
        .then(({ data }) => {
          resolve(data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }
}

export default AuthService;
